import { openItemFlowsModal } from "components/ItemFlowsModal";
import { ItemFlowDirection, ItemFlowId } from "data/types";
import { getDefaultsConfig } from "data/constants";

type Context = {
    itemUri: string,
    files?: Array<DroppedFile>,
    flowId?: string,
    categoryId?: string,
};

/**
 * opens the upload dialog to the given itemUri
 *
 * @param {{ itemUri: string }} { itemUri }
 * @param {{ files?: Array<DroppedFile> }} { files }
 * @param {{ flowId?: string}} { flowId } pre-selected flow.id, defaults to doc_upload
 * @param {{ categoryId?: string}} { categoryId } pre-selected category.id, defaults to document
 */

class doc_upload {
    execute = async ({
        itemUri,
        formatId,
        files,
        flowId,
        categoryId = "document",
    }: Context) => {
        const defaults = getDefaultsConfig(itemUri, formatId);
        await openItemFlowsModal({
            itemUri,
            direction: ItemFlowDirection.in,
            flowId: flowId ?? defaults?.upload?.flowId ?? ItemFlowId.doc_upload,
            categoryId,
            files,
        });
        return true;
    };
}

export default doc_upload;
